
let headerHeight = 36; //头部框的高度
let fieldHeight = 30; //字段框的高度
let width = 200; //table的宽度，不包含圆点
let textHeight = 20;

// let height; // 默认不做配置，根据字段数量计算得出

let frameRadius = 6;
let headerColor = "#373B47"
let mainColor = "#13132B"
let mainOpacity = 0.5;
// 表头 文字（数据库名）
let tableTitleTop = 10
let tableTitleLeft = 26;
let tableTitleWidth = 160
//表名 文字
let tableNameTop = headerHeight + 10;
let tableNameLeft = 30;
let tableNameTextWidth = 140
//字段配置
let fieldsTop = headerHeight + 30;
let fieldsWidth = 160
let fieldsLeft = (width - fieldsWidth) / 2
let fieldsGap = 6;
let fieldColor = "#373B47";
let fieldHighlightColor = "#59B3FF"
let fieldTextWidth = 100
// 收放按钮配置
let iconTop = headerHeight + 15;
let iconLeft = width - 30;
let basePolylinePoints = [[1, 4], [5, 0], [9, 4]]
// 动画配置
let animationDuring = 100;
// 端点配置
let portFillColor = "#258FFF"
let portRadius = 0;
// 血缘按钮配置
let bloodOff = require("./off.svg")
let bloodOn = require("./on.svg")

//默认展开还是收起
let statusDefault = "collapse"

// tooltip
let tooltipRect = null;
let tooltipText = null;
let tooltipG = null;
let tooltipHeight = 20;
//非配置项——计算得出
let collapseHeight = fieldsTop + 10
let defaultHeight;



// icon path 的点
function getIconPoints(basePoints, top, left) {
    return basePoints.map(v => [v[0] + left, v[1] + top])

}
// icon 点击范围扩大化
function getIconTriggerRect(points, extension = 0) {

    let [minX, minY, maxX, maxY] = points.reduce((a, b) => [Math.min(a[0], b[0]), Math.min(a[1], b[1]), Math.max(a[0], b[0]), Math.max(a[1], b[1])])
    return [
        minX - extension,
        minY - extension,
        maxX - minX + extension,
        maxY - minY + extension
    ]
}

const renderGroup = function (el, group, i, ctx) {
    let nodes = group.nodes || [];
    let fieldsNum = nodes.filter(v => v.category == 'field').length;


    let height = fieldsNum * (fieldHeight + fieldsGap) + fieldsTop + 10

    defaultHeight = statusDefault == "collapse" ? collapseHeight : height;

    //头部方框
    let dHeader = `M0 ${headerHeight}V${frameRadius} A${frameRadius} ${frameRadius} 0 0,1 ${frameRadius} ${0} H${width - frameRadius}
            A${frameRadius} ${frameRadius} 0 0,1 ${width} ${frameRadius} V${headerHeight}
            Z`
    let header = el.path(dHeader).attr({ fill: headerColor })
    // 头部文字
        let headertext = el.el("foreignObject",{x:tableTitleLeft, y:tableTitleTop,height:textHeight,width:tableTitleWidth}).addClass("blood-pointer")
        .mouseover(function(){
            let x = this.attr("x")
            let y = this.attr("y")
            switchToolTip(true,x,y,group.databaseName,this)
        }).mouseout(function(){
            switchToolTip(false)
        })
        headertext.node.innerHTML=`<p class="blood-title">${group.databaseName}</p>`;
        
    // 表名
/*     let tableTitleText = el.text(tableNameLeft, tableNameTop, group.name).attr({
        style: "font-size:12px",
        fill: "#fff",

    }).mouseover(function(){
        let x = this.attr("x")
        let y = this.attr("y")
        switchToolTip(true,x,y, group.name,this)
    }).mouseout(function(){
        switchToolTip(false)
    }) */
    let tableTitleText = el.el("foreignObject",{x:tableNameLeft, y:tableNameTop,height:textHeight,width:tableNameTextWidth}).addClass("blood-pointer")
    .mouseover(function(){
        let x = this.attr("x")
        let y = this.attr("y")
        switchToolTip(true,x,y, group.name,this)
    }).mouseout(function(){
        switchToolTip(false)
    })
    tableTitleText.node.innerHTML=`<p class="blood-title">${group.name}</p>`;
    // 收放按钮
    let polylinePoints = getIconPoints(basePolylinePoints, iconTop, iconLeft)

    let icon = el.polyline(polylinePoints.reduce((a, b) => { a.push(...b); return a }, [])).attr({ stroke: "#67677E", strokeWidth: 2, fill: "none", })
    //由于 icon 本身可点击范围太小，因此加一个透明矩形来增加点击范围
    let iconTrigger = el.rect(...getIconTriggerRect(polylinePoints, 10)).attr({ opacity: 0 })
    // 将矩形和icon 加入group
    let iconGroup = el.group(icon, iconTrigger).addClass("blood-pointer")
        // 收放按钮 点击事件
        .click(function () {
            let mainHeight = g.selectAll("[chosen='highlight']").length * fieldHeight + fieldsTop + 10;

            let dMainOriginNew = getDMainByHeight(mainHeight)
            // 根据不通状态来 进行收放 动画
            if (g.attr().status == "expand") {
                nodeCollapseAnimation(g, mainHeight)
                // 收放动画 后，有一个回调函数来调整 相关连线的样子
                main.animate({ d: dMainOriginNew }, animationDuring, () => { ctx.lineFollowing(g); })
            } else {
                nodeExpandAnimation(g, height)
                // 收放动画 后，有一个回调函数来调整 相关连线的样子

                main.animate({ d: expandDMain }, animationDuring, () => { ctx.lineFollowing(g) })
            }
            switchStatus(g)

        }).mousedown(function (e) {
            e.stopPropagation();
        })
    //主框 ——即包围字段节点的外框
    // 默认d
    let expandDMain = getDMainByHeight(height)
    let defaultDMain = getDMainByHeight(defaultHeight)
    // let dMain = `M0 ${headerHeight}V${defaultHeight - frameRadius} A${frameRadius} ${frameRadius} 0 0,0 ${frameRadius} ${defaultHeight} H${width - frameRadius} 
    //             A${frameRadius} ${frameRadius} 0 0,0 ${width} ${defaultHeight - frameRadius} V${headerHeight}
    //             Z`
    let main = el.path(defaultDMain).attr({ fill: mainColor, opacity: mainOpacity, part: "mainframe" })

    var g = el.group(header, main, headertext, tableTitleText, iconGroup).attr({ status: statusDefault }).addClass("hover-move")
    return g;
}

const renderNode = function (el, node, i, ctx) {
    // 如果是 表的node 则另外处理，不再增加字段框框等元素
    if (node.category == "table") {
        return renderTableNode(el, node);
    }
    // 方框
    let rect = el.rect(fieldsLeft, fieldsTop, fieldsWidth, fieldHeight).attr({
        fill: fieldColor,

    })

    // 文字——字段名

    let text =  el.el("foreignObject",{x:40, y:fieldsTop + 6,height:textHeight,width:fieldTextWidth}).addClass("blood-pointer")
      .mouseover(function(){
        let x = this.attr("x")
        let y = this.attr("y")
        switchToolTip(true,x,y, node.name,this)
    }).mouseout(function(){
        switchToolTip(false)
    })
    text.node.innerHTML=`<p class="blood-title">${node.name}</p>`;
    // 血缘开关按钮
    let bloodButton = el.image(bloodOff, 160, fieldsTop + 12, 10, 10).attr({ active: 0 }).addClass("blood-pointer")
        .click(function () {
            let active = this.attr("active")
            //  将其他所有的表都收起
            let collapseGs = ctx.el.selectAll("[f-type='group'][status='collapse']")
            let toBeCollapseGs = [];
            collapseGs.forEach(g => {
                let highlightNodes = g.selectAll("[chosen='highlight']")

                if (highlightNodes.length > 0)
                    toBeCollapseGs.push(g)
            })

            let nodes = ctx.el.selectAll("[f-type='node'][category='field']")
            nodes.forEach(node => {
                node.select("image").attr({ href: bloodOff, active: 0 })
                node.select("rect").attr({ fill: fieldColor })
                node.attr({ chosen: "dark" })
            })
            if (active == '0') {
                // 开关启动
                this.attr({ active: 1 })
                // 将之前启动的开关相关node 选出来，颜色还原回去，开关样子还原回去

                // 点击的这个开关 变成开的样子
                this.attr({ href: bloodOn, active: 1 })
                // 点击的这个开关所在节点高亮
                rect.attr({ fill: fieldHighlightColor })
                g.attr({ chosen: "highlight" })
            } else {
                // 开关关闭时。颜色还原
                this.attr({ active: 0, href: bloodOff })
                rect.attr({ fill: fieldColor })
            }
            // 抛出点击事件 让外部输入连线数据
            if (ctx.config.onclickField) {

                let newResult = ctx.config.onclickField(g, node.id, parseInt(this.attr("active")))

                if (!newResult) return;
                let { relativeLinks, unrelativeLinks } = newResult;
                // 给血缘相关线的数据加标记，以便在外部回调函数时控制其颜色
                relativeLinks.forEach(link => {
                    link.tag = "blood"
                })
                // 最终需要绘制的连接线
                let newLinks = [...relativeLinks, ...unrelativeLinks]

                // 重绘 links
                ctx.reRenderLinks(newLinks)

                // 获取到所有血缘相关的字段节点
                let nodeIds = relativeLinks.reduce((a, b) => {
                    a.push(b.source.nodeId, b.target.nodeId);
                    return a;
                }, [])
                let nodeGroupSet = new Set();
                nodeIds.forEach(nodeId => {
                    let node = ctx.el.select(`[f-type='node'][n-id='${nodeId}']`).attr({ chosen: "highlight" })
                    node.select("rect").attr({ fill: fieldHighlightColor })

                    let gid = node.attr("g-id")
                    nodeGroupSet.add(gid)

                })
                // 该收的收起来
                toBeCollapseGs.forEach(toBeCollapseG => {
                    let mainHeight = fieldsTop + 10;
                    nodeCollapseAnimation(toBeCollapseG, mainHeight)
                    toBeCollapseG.select("[part='mainframe']").animate({ d: getDMainByHeight(mainHeight) }, animationDuring, () => { ctx.lineFollowing(toBeCollapseG); })
                })

                // 将收起状态的但是需要高亮的节点展开
                nodeGroupSet.forEach(gid => {
                    let group = ctx.el.select(`[f-type='group'][g-id='${gid}']`)
                    if (group.attr("status") == 'expand') return;
                    let mainHeight = group.selectAll("[chosen='highlight']").length * fieldHeight + fieldsTop + 10;
                    nodeCollapseAnimation(group, mainHeight)
                    group.select("[part='mainframe']").animate({ d: getDMainByHeight(mainHeight) }, animationDuring, () => { ctx.lineFollowing(group); })
                })


            }

        }).mousedown(e => { e.stopPropagation() })
    // 初始化的一些配置
    let translateTop = statusDefault == "collapse" ? 0 : (fieldHeight + fieldsGap) * i
    let opacity = statusDefault == "collapse" ? -1 : 1
    let className = statusDefault == "collapse" ? "blood-hide" : "";
    let g = el.g(rect, text, bloodButton).attr({ transform: `translate(0,${translateTop})`, opacity, status: 'expand', category: "field", chosen: "dark" }).addClass(className);

    return g
}


const renderPort = function (el, port, portIndex, node, nodeIndex) {
    // 如果是表级的 端口，另外处理端口的坐标位置
    if (node.category == "table") {
        return renderTablePort(el, port, portIndex, node, nodeIndex);
    }
    // 画端口
    let circle = el.circle(0, 0, 0)
    if (port.direction == "left")
        circle = el.circle(fieldsLeft, fieldsTop + fieldHeight / 2, portRadius).attr({
            fill: portFillColor,
        })
    if (port.direction == "right")
        circle = el.circle(fieldsLeft + fieldsWidth, fieldsTop + fieldHeight / 2, portRadius).attr({
            fill: portFillColor,

        })
    return circle;

}
// 获取动画起始 主框d  的方法
function getDMainByHeight(h) {
    return `M0 ${headerHeight}V${h - frameRadius} A${frameRadius} ${frameRadius} 0 0,0 ${frameRadius} ${h} H${width - frameRadius} 
    A${frameRadius} ${frameRadius} 0 0,0 ${width} ${h - frameRadius} V${headerHeight}
    Z`
}
// 画表级的node
function renderTableNode(el, node) {
    return el.g().attr({ category: "table", opacity: -1 }).animate({ opacity: 1 }, animationDuring)
}
// 画表级的端口
function renderTablePort(el, port, portIndex, node, nodeIndex) {

    let circle = el.circle(0, 0, 0)
    if (port.direction == "left")
        circle = el.circle(0, defaultHeight / 2, portRadius).attr({
            fill: portFillColor,
        })
    if (port.direction == "right")
        circle = el.circle(width, defaultHeight / 2, portRadius).attr({
            fill: portFillColor,
        })
    return circle;
}
// 字段节点 收起的动画
function nodeCollapseAnimation(g, h) {
    let nodes = g.selectAll("[f-type='node'][category='field'][chosen='dark']")

    nodes.attr({ status: "collapse" })
    nodes.animate(
        {
            transform: `translate(0,0)`,
            opacity: -1
        },
        animationDuring,
        function () {
            nodes.forEach(el => el.addClass("blood-hide"))
        }
    );
    let hightlightNodes = g.selectAll("[f-type='node'][category='field'][chosen='highlight']")

    hightlightNodes.attr({ status: "collapse" })
    hightlightNodes.forEach((node, i) => {
        node.animate(
            { transform: `translate(0,${(fieldHeight + fieldsGap) * i})`, opacity: 1 },
            animationDuring,
            function () {
                hightlightNodes.forEach(el => el.removeClass("blood-hide"))
            }
        )
    })
    let tableNodeLeft = g.select("[f-type='node'][category='table']").select("[n-port='left']")
    tableNodeLeft.animate({ cx: 0, cy: h / 2 }, animationDuring)
    let tableNodeRight = g.select("[f-type='node'][category='table']").select("[n-port='right']")
    tableNodeRight.animate({ cx: width, cy: h / 2 }, animationDuring)
}
// 字段节点扩展的动画
function nodeExpandAnimation(g, height) {

    let nodes = g.selectAll("[f-type='node'][category='field']")
    nodes.attr({ status: "expand" })
    nodes.forEach(el => el.removeClass("blood-hide"))
    nodes.forEach((node, i) => {
        node.animate(
            { transform: `translate(0,${(fieldHeight + fieldsGap) * i})`, opacity: 1 },
            animationDuring,
        )
    })

    let tableNodeLeft = g.select("[f-type='node'][category='table']").select("[n-port='left']")
    tableNodeLeft.animate({ cx: 0, cy: height / 2 }, animationDuring)

    let tableNodeRight = g.select("[f-type='node'][category='table']").select("[n-port='right']")
    tableNodeRight.animate({ cx: width, cy: height / 2 }, animationDuring)
}
// 扩展/收起 切换状态函数
function switchStatus(dom) {
    if (dom.attr().status == "expand") {
        dom.attr({ status: "collapse" })
    } else {
        dom.attr({ status: "expand" })
    }
}
function init(ctx) {
    // 增加tooltip 
    tooltipRect = ctx.el.rect(0, 0, tooltipHeight, 10,2,2).attr({fill:"#216AB5",stroke:"#fff",strokeWidth:1})
    tooltipText = ctx.el.text(0, 0, "text").attr({fill:"#fff",style:"font-size:12px"})
    tooltipG = ctx.el.g(tooltipRect, tooltipText).attr({opacity:0}).addClass("blood-events")
    let config = ctx.config;
    if (config && config.groupConfig) {
        statusDefault = config.groupConfig.statusDefault || statusDefault;
    }

}
function switchToolTip(isShow,x, y, text,el) {
    
    if(!tooltipRect || !tooltipText || !tooltipG) return;
    if(!isShow){
        tooltipG.animate({opacity:0},200)
        return;
    }

    tooltipText.node.innerHTML = text;
    let width = tooltipText.node.clientWidth+10
    tooltipRect.attr({x:-6,y:-14,height:tooltipHeight,width})
    el.after(tooltipG)
    tooltipG.attr({transform:`translate(${x},${parseFloat(y)+14})`})
    tooltipG.animate({opacity:1},200)
}
function isOverWidthLimit(el,width){
    return el.node.clientWidth>width
}
export default {
    renderGroup, renderNode, renderPort, init
}


// WEBPACK FOOTER //
// ./src/components/DataFlow/groupRender/bloodRender.js